import type { AuditTrail } from '@openx/types/auditTrail';

export const MCP_ACTOR_PREFIX = 'MCP (AI Agent) on behalf of';

export function getAuditTrailReason(auditTrail: AuditTrail): string {
  const actor = auditTrail.real_name || auditTrail.real_user || auditTrail.user.name || auditTrail.user.email;

  if (auditTrail.reason === 'mcp') {
    return `${MCP_ACTOR_PREFIX} ${actor}`;
  }

  return actor;
}
